export var OrderBookDetailsMapper = function (response) {
    return response;
};
export var OrderBookListMapper = function (response) {
    return response;
};
